import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=bb793904&scoped=true&"
import script from "./SettingDialog.vue?vue&type=script&lang=js&"
export * from "./SettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./SettingDialog.vue?vue&type=style&index=0&id=bb793904&scoped=true&lang=css&"
import style1 from "./SettingDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb793904",
  null
  
)

export default component.exports